import activityAbTest from './en-US/activityAbTest';
import activityAuto from './en-US/activityAuto';
import activityCycle from './en-US/activityCycle';
import activityManage from './en-US/activityManage';
import activityReport from './en-US/activityReport';
import activityWhatsApp from './en-US/activityWhatsApp';
import adminManage from './en-US/adminManage';
import aiSummary from './en-US/aiSummary';
import apiErrorCode from './en-US/apiErrorCode';
import businessManage from './en-US/businessManage';
import common from './en-US/common';
import components from './en-US/components';
import contactManage from './en-US/contactManage';
import contactReport from './en-US/contactReport';
import countryConfig from './en-US/countryConfig';
import dataReport from './en-US/dataReport';
import exportCenter from './en-US/exportCenter';
import home from './en-US/home';
import labelManage from './en-US/labelManage';
import languageConfig from './en-US/languageConfig';
import placeholderManage from './en-US/placeholderManage';
import preferenceManage from './en-US/preferenceManage';
import segmentsManage from './en-US/segmentsManage';
import settingManage from './en-US/settingManage';
import templateManage from './en-US/templateManage';
import testerManage from './en-US/testerManage';
import userJourney from './en-US/userJourney';
import whatsAppTemplate from './en-US/whatsAppTemplate';

export default {
  ...apiErrorCode,
  ...common,
  ...components,
  ...countryConfig,
  ...languageConfig,
  ...adminManage,
  ...businessManage,
  ...settingManage,
  ...home,
  ...activityManage,
  ...activityCycle,
  ...activityAbTest,
  ...activityAuto,
  ...userJourney,
  ...contactManage,
  ...segmentsManage,
  ...labelManage,
  ...preferenceManage,
  ...templateManage,
  ...placeholderManage,
  ...dataReport,
  ...activityReport,
  ...contactReport,
  ...activityWhatsApp,
  ...whatsAppTemplate,
  ...testerManage,
  ...exportCenter,
  ...aiSummary,
};
